module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isModalActive) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.isModalActive = false
      }
    }
  }), _c('div', {
    staticClass: "box position-relative has-text-left margin-right-10 margin-left-10"
  }, [_vm._m(0), _c('div', _vm._l((_vm.lista), function(o, index) {
    return _c('span', {
      staticClass: "text-small"
    }, [_vm._v(_vm._s(o.descripcion)), _c('br')])
  }), 0), _c('br'), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.goToMisDocumentos()
      }
    }
  }, [_vm._v("Ir a mis documentos por firmar")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "name"
  }, [_vm._v("Tienes los siguientes documentos por firmar y cargar:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1c0dce8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Mis_Documentos_Sin_Cargar.vue
// module id = 957
// module chunks = 0